<template>
  <div :class="[{ 'main-item-detail-chat': isItemDetailContent }]">
    <md-content
      class="md-scrollbar chat-content"
      :class="[
        { 'chat-item-detail-content': isItemDetailContent },
        { 'item-card-chat': !isItemDetailContent },
      ]"
      ref="chatContent"
    >
      <MsgsChatDisplay :messages="getAllMsgs(usrMessages)" />
    </md-content>
    <hr />
    <CardChatResponse
      @send="sendMsg"
      v-if="showResponse"
      :itemName="item.title"
      :isItemDetailContent="isItemDetailContent"
    />
    <div class="replied-content" v-else>
      <span @click="goToMessageCenter">Go to messages</span
      >
    </div>
  </div>
</template>

<script>
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import MsgsChatDisplay from "@/components/molecules/MsgsChatDisplay.vue";
import CardChatResponse from "@/material-components/molecules/CardChatResponse.vue";
export default {
  name: "SCardChat",
  props: ["usrMessages", "item", "partner", "isItemDetailContent"],
  data() {
    return {
      payload: {},
      showResponse: true,
    };
  },
  mixins: [ChatHelperVue, UserHelperVue],
  components: {
    MsgsChatDisplay,
    CardChatResponse,
  },
  methods: {
    goToMessageCenter() {
      const chat = this.item.id;
      const lastMessage = this.usrMessages ? this.usrMessages.messages[
        this.usrMessages.messages.length - 1
      ].id : 0;
      this.$router.push({
        path: "message-center",
        query: {
          chat: chat,
          id: lastMessage,
          type: "item",
        }
      });
    },
    scrollToBottom() {
      this.$refs.chatContent.$el.scrollTop =
      this.$refs.chatContent.$el.scrollHeight;
    },
    hideResponse() {
      this.showResponse = false;
    },
    async sendMsg(value) {
      let newChatUser = false;
      if (this.allMessages[0] && this.allMessages[0].receiver) {
        this.payload = this.allMessages[0];
      } else {
        this.payload.receiver = { newMessage: {} };
        newChatUser = true;
      }
      await this.postUserItemMessage({
        message: this.payload,
        partner: this.partner.id,
        item: this.item.id,
        postMsg: value,
        newChat: newChatUser,
      });
      await this.fetchUserMessages();
      this.$nextTick(() => {
        this.focusInput();
      });
      setTimeout(() => {
        this.scrollToBottom();
      }, 200);
      this.payload = {};
    },
  },
  computed: {
    allMessages() {
      return [...(this.usrMessages?.messages ?? [])];
    },
  },
  mounted() {
    setTimeout(() => {
      this.scrollToBottom();
    }, 800);
  },
};
</script>

<style lang="scss">
.chat-content .notification-event {
  max-width: 82% !important;
  width: 82%;
}
.chat-content .notification-list li {
  padding: 10px !important;
}
.chat-content .notification-list .notification-event {
  padding-left: 0 !important;
}
</style>

<style lang="scss" scoped>
.item-card-chat {
  max-width: 400px;
  max-height: 130px;
  min-height: 130px;
}
.md-content {
  overflow: auto;
}
.replied-content {
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    margin-top: 1rem;
    text-decoration: none !important;
    color: $tertiary;
    cursor: pointer;
  }
  span:hover {
    color: $tertiary;
  }
}
.main-item-detail-chat {
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 4px;
  margin: -0.61rem 0.5rem 0 0.5rem !important;
  padding: 1rem;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.chat-item-detail-content {
  max-height: 250px;
}
@media screen and (max-width: 960px) {
  .main-item-detail-chat {
    margin-top: -4.1rem !important;
  }
}
@media screen and (max-width: 440px) {
  .main-item-detail-chat {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
</style>
